import React, { useState } from "react";
import { BellRing } from "lucide-react";
import { saveRateAlert } from "../lib/store";

// Inline chat form: customer sets a 24K/gram gold-rate alert. Mr. Regal collects the details.
export const RateAlertForm = ({ defaults = {}, onDone }) => {
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [target, setTarget] = useState(defaults.target ? String(defaults.target) : "");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    const digits = (phone || "").replace(/\D/g, "");
    const t = parseFloat(target);
    if (!name.trim()) return setErr("Please share your name.");
    if (digits.length < 7) return setErr("Please enter a valid WhatsApp number.");
    if (!(t > 0)) return setErr("Please enter your target price per gram.");
    if (defaults.current != null && t >= Number(defaults.current)) {
      return setErr(`Choose a price below today's 24K rate of $${Number(defaults.current).toFixed(2)}/g.`);
    }
    setErr("");
    setBusy(true);
    try {
      await saveRateAlert({ name: name.trim(), phone: phone.trim(), target: t });
      onDone(
        `Splendid, ${name.trim().split(" ")[0]}. Your alert is set — the moment 24-karat gold reaches $${t.toFixed(2)} per gram, our team will WhatsApp you on ${phone.trim()}. A pleasure to watch the market on your behalf.`
      );
    } catch (e2) {
      setErr(e2?.response?.data?.detail || "Forgive me — I couldn't set that just now. Please try again in a moment.");
      setBusy(false);
    }
  };

  return (
    <form onSubmit={submit} className="mt-2 max-w-[92%] bg-white border border-[#c9a24b]/60 px-3.5 py-3 space-y-2" data-testid="rate-alert-form">
      <div className="flex items-center gap-1.5 text-[10px] uppercase tracking-[0.15em] text-[#8a6a1f]">
        <BellRing size={12} /> Gold rate alert (24K · per gram)
      </div>
      {defaults.current != null && (
        <p className="text-[11px] text-[#7a7160]" data-testid="rate-alert-current">Today's 24K rate: <span className="font-semibold text-[#171310]">${Number(defaults.current).toFixed(2)}</span>/g</p>
      )}
      <input value={name} onChange={(e) => setName(e.target.value)} placeholder="Your name" data-testid="rate-alert-name"
        className="w-full text-[13px] border border-[#e0d5bb] px-2.5 py-1.5 outline-none focus:border-[#a8842c] bg-white text-[#171310]" />
      <input value={phone} onChange={(e) => setPhone(e.target.value)} placeholder="WhatsApp number" inputMode="tel" data-testid="rate-alert-phone"
        className="w-full text-[13px] border border-[#e0d5bb] px-2.5 py-1.5 outline-none focus:border-[#a8842c] bg-white text-[#171310]" />
      <div className="flex items-center border border-[#e0d5bb] focus-within:border-[#a8842c] bg-white">
        <span className="pl-2.5 text-[13px] text-[#8f8571]">$</span>
        <input value={target} onChange={(e) => setTarget(e.target.value)} placeholder="Alert me below…" inputMode="decimal" data-testid="rate-alert-target"
          className="flex-1 text-[13px] px-1.5 py-1.5 outline-none bg-transparent text-[#171310]" />
        <span className="pr-2.5 text-[11px] text-[#8f8571]">/gram</span>
      </div>
      {err && <p className="text-[11px] text-[#8c2f1b]" data-testid="rate-alert-error">{err}</p>}
      <button type="submit" disabled={busy} data-testid="rate-alert-submit"
        className="w-full rounded-none bg-[#171310] hover:bg-[#3a2f1d] text-[#e9d9ac] tracking-[0.14em] uppercase text-[11px] py-2 disabled:opacity-50 transition-colors">
        {busy ? "Setting…" : "Set my gold alert"}
      </button>
    </form>
  );
};
